// Rusada → TechLog flight validation schemas
// Following single source of truth principle: reuse API-level Zod schemas
import {
  ZRusadaFlightResponse,
  ZRusadaRegistrationResponse,
  ZRusadaPlacesResponse,
} from '../../../../activities/api/rusada/rusada.zod';
import { ZTechlogAirport } from '../../../../types/techLog/airport.zod';
import { ZTechlogSectorCreateInput } from '../../../../types/techLog/sector.zod';
import { z } from 'zod';

// Composite input validation: Context structure with Rusada and TechLog data
// This matches the context provider's getRequiredResolvers(): ['rusada.flight', 'rusada.registration', 'rusada.airports.departure', 'rusada.airports.arrival', 'rusada.airports.diverted', 'techlog.aircraft']
export const ZRusadaToTechLogFlightInput = z.object({
  rusada: z.object({
    flight: ZRusadaFlightResponse,
    registration: ZRusadaRegistrationResponse,
    airports: z.object({
      departure: ZRusadaPlacesResponse.extend({
        techlogId: z.string().optional(),
      }),
      arrival: ZRusadaPlacesResponse.extend({
        techlogId: z.string().optional(),
      }),
      diverted: ZRusadaPlacesResponse.extend({
        techlogId: z.string().optional(),
      }).optional(),
      actualArrival: ZRusadaPlacesResponse.extend({
        techlogId: z.string().optional(),
        rusadaId: z.number().optional(),
      }).optional(),
    }),
  }),
  techlog: z.object({
    aircraft: z.any(), // TODO: Import proper ZTechlogAircraftResponse when available
    airport: z.object({
      departure: ZTechlogAirport,
      arrival: ZTechlogAirport,
    }),
  }),
  precomputed: z
    .object({
      duration: z
        .object({
          blockTime: z.number().optional(),
          flightTime: z.number().optional(),
          groundTime: z.number().optional(),
        })
        .optional(),
      dutyTime: z
        .object({
          scheduled: z.number().optional(),
          actual: z.number().optional(),
        })
        .optional(),
    })
    .optional(),
});

// Output validation: TechLog sector creation input (destination API input type)
export const ZRusadaToTechLogFlightOutput = ZTechlogSectorCreateInput;

// Re-export types for convenience
export type RusadaToTechLogFlightInput = z.infer<
  typeof ZRusadaToTechLogFlightInput
>;
export type RusadaToTechLogFlightOutput = z.infer<
  typeof ZRusadaToTechLogFlightOutput
>;
